<app-pathway-call-header
  title="Assessment"
  [showCallDetails]="false"
  [showSettings]="false"
  (leaveStepClicked)="handleClose()"
/>

<ng-template #tabContent let-tab>
  <div class="card-content">
    @for (block of tab.blocks; track $index) {
      @switch (block.type) {
        @case ('heading') {
          <p class="question">{{ block.text }}</p>
        }
        @case ('subheading') {
          <p class="question">{{ block.text }}</p>
        }
        @case ('body') {
          <p class="description">{{ block.text }}</p>
        }
        @case ('bullet') {
          <p class="description">• {{ block.text }}</p>
        }
        @case ('check-item') {
          <p class="description">{{ block.text }}</p>
        }
      }
    }
  </div>
</ng-template>

<div class="body">
  @if (isCallDetailsLoading()) {
    <qai-loading size="medium" />
  } @else if (!isMobile()) {
    <qai-carousel>
      @for (tab of parsedTabs(); track tab.tabSequence) {
        <div qaiCarouselItem class="card">
          <h3 class="card-title">{{ tab.tabTitle }}</h3>
          <ng-container *ngTemplateOutlet="tabContent; context: { $implicit: tab }" />
        </div>
      }

      <div qaiCarouselItem class="card">
        <h3 class="card-title">Device Setup</h3>
        <app-device-settings-content [deviceSettingsService]="deviceSettingsService" (diagnosticRunningChange)="isDiagnosticRunning.set($event)" />
      </div>
    </qai-carousel>
  } @else {
    <div class="mobile-stack">
      @for (tab of parsedTabs(); track tab.tabSequence) {
        <div class="card">
          <h3 class="card-title">{{ tab.tabTitle }}</h3>
          <ng-container *ngTemplateOutlet="tabContent; context: { $implicit: tab }" />
        </div>
      }

      <div class="card">
        <h3 class="card-title">Device Setup</h3>
        <app-device-settings-content [deviceSettingsService]="deviceSettingsService" (diagnosticRunningChange)="isDiagnosticRunning.set($event)" />
      </div>
    </div>
  }
</div>

<div class="footer">
  <button
    qai-button
    kind="primary"
    size="medium"
    [disabled]="isBeginDisabled()"
    (click)="handleBeginSession()"
  >
    Begin Session
  </button>
</div>
